import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { LabelSmall } from '@styled';

const SectionBreadcumb = ({ children, isActive, isLast, route }) => {
    const history = useHistory();

    return (
        <div className="d-flex align-items-center">
            <a
                href={route}
                onClick={e => {
                    e.preventDefault();
                    history.push(route);
                }}
            >
                <LabelSmall
                    className={classNames({
                        'text-medium-gray': !isActive,
                        'text-black': isActive,
                    })}
                >
                    {children}
                </LabelSmall>
            </a>

            {!isLast && (
                <svg
                    className="mx-2"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.5 3.5L11 8L6.5 12.5"
                        stroke="currentColor"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </div>
    );
};

SectionBreadcumb.propTypes = {
    children: PropTypes.node.isRequired,
    isActive: PropTypes.bool,
    isLast: PropTypes.bool,
    route: PropTypes.string,
};

export default SectionBreadcumb;
